import { FileFormats } from "../../../../components/finalForms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
  projectId: "",
  synergyTypeID: "",
  title: "",
  priorityId: "",
  reportedBy: "",
  description: "",
  attachments: "",
  affectedId: "",
  changeRequestID: "",
  reasonForChange: "",
  submittedDate: "",
  userGoal: "",
  benefit: "",
  acceptanceCriteria: "",
  userStoryID: "",
  proposedBy: "",
  businessValue: "",
  expectedOutcomes: "",
  considerations: "",
};

export const AddProjectSynergyFormData = {
  name: "ProjectSynergy Form",
  initialState: initState,
  section: [
    {
      sectionId: "ProjectSynergy",
      title: "ProjectSynergy Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-8",
      },
      wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
      fields: [
        {
          id: "title",
          label: "Synergy Title",
          Field_Name: "synergy title",
          fieldType: FormFieldTypes.INPUT,
          dataField: "title",
          fieldSetting: {
            placeholder: "Please Enter Synergy Title",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 ",
          },
        },
        {
          id: "synergyTypeID",
          label: "Synergy Type",
          Field_Name: "synergy type",
          fieldType: FormFieldTypes.SELECT,
          dataField: "synergyTypeID",
          fieldSetting: {
            placeholder: "Please Select Synergy Type",
            allowSpace: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 ",
          },
        },
        {
          id: "submittedDate",
          label: "Submitted Date",
          Field_Name: "Submitted Date",
          fieldType: FormFieldTypes.DATEPICKER,
          dataField: "submittedDate",
          fieldSetting: {
            placeholder: "Please Enter Submitted Date",
            allowSpace: true,
            dateConfig: {
              dateFormat: "MM/dd/yyyy",
              showTimeSelect: true,
            }
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 validation-left-0"
          },
        },

        {
          id: "projectId",
          label: "Project",
          Field_Name: "project",
          fieldType: FormFieldTypes.SELECT,
          dataField: "projectId",
          fieldSetting: {
            placeholder: "Please Select Project",
            allowSpace: true,
            isDisable: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },
        },
        {
          id: "reportedBy",
          label: "Reported User",
          Field_Name: "reported user",
          fieldType: FormFieldTypes.SELECT,
          dataField: "reportedBy",
          fieldSetting: {
            placeholder: "Please Select Reported User",
            allowSpace: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 validation-left-0 ",
          },
        },
        {
          id: "priorityId",
          label: "priority",
          Field_Name: "priority",
          fieldType: FormFieldTypes.SELECT,
          dataField: "priorityId",
          fieldSetting: {
            placeholder: "Please Select Priority",
            allowSpace: true,
            options: [],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 ",
          },
        },

        {
          id: "description",
          label: "Description",
          Field_Name: "description",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "description",
          fieldSetting: {
            placeholder: "Please Enter Description",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-2",
          },
        },
        {
          id: "attachments",
          label: " Attachments",
          Field_Name: "attachments",
          fieldType: FormFieldTypes.FILE,
          dataField: "attachments",
          fieldSetting: {
            placeholder: "Upload File",
            allowMultipleFiles: true,
            acceptedFileFormats: [
              FileFormats.ALL,
              // ImageFormats.ANY
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 8, // Maximum File size in MB
          },
          //   validation: [{ type: validationTypes.FILE }],
          style: {
            containerCss:
              "col-lg-6 col-md-3 mb-2",
          },
        },
      ],
    },
    {
      sectionId: "ProjectSynergy1",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "affectedId",
          label: "Affected Modules",
          Field_Name: "affected modules",
          fieldType: FormFieldTypes.SELECT,
          dataField: "affectedId",
          fieldSetting: {
            placeholder: "Please Select Affected Modules",
            allowSpace: true,
            options: [],
            isMultiSelect: true
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0 mb-1",
          },
        },

        // {
        //   id: "changeRequestID",
        //   label: "Change Request",
        //   Field_Name: "change request",
        //   fieldType: FormFieldTypes.INPUT,
        //   dataField: "changeRequestID",
        //   fieldSetting: {
        //     placeholder: "Please Enter change Request",
        //     allowSpace: true,
        //     //  isDisable: true,
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-4 col-md-6 validation-left-0 mb-1",
        //   },
        // },
        // {
        //   id: "submittedDate",
        //   label: "Submitted Date",
        //   Field_Name: "Submitted Date",
        //   fieldType: FormFieldTypes.DATEPICKER,
        //   dataField: "submittedDate",
        //   fieldSetting: {
        //     placeholder: "Please Enter Submitted Date",
        //     allowSpace: true,
        //     dateConfig: {
        //       dateFormat: "MM/dd/yyyy h:mm aa",
        //       showTimeSelect: true,
        //     }
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-4 col-md-6 validation-left-0"
        //   },
        // },
        {
          id: "reasonForChange",
          label: "Reason For Change",
          Field_Name: "reason for change",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "reasonForChange",
          fieldSetting: {
            placeholder: "Please Enter Reason For Change",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-8 col-md-6 mb-1 validation-left-0",
          },
        },
      ]
    },
    {
      sectionId: "ProjectSynergy2",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [

        {
          id: "userGoal",
          label: "User Goal",
          Field_Name: "user goal",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "userGoal",
          fieldSetting: {
            placeholder: "Please Enter User Goal",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "benefit",
          label: "Benefit",
          Field_Name: "benefit",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "benefit",
          fieldSetting: {
            placeholder: "Please Enter Benefit",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 col-md-6 mb-1 validation-left-0",
          },
        },

        {
          id: "acceptanceCriteria",
          label: "Acceptance Criteria",
          Field_Name: "acceptance criteria",
          fieldType: FormFieldTypes.TEXTEDITOR,
          dataField: "acceptanceCriteria",
          fieldSetting: {
            placeholder: "Please Enter Acceptance Criteria",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-2",
          },
        },
        // {
        //   id: "userStoryID",
        //   label: "User Story",
        //   Field_Name: "user story",
        //   fieldType: FormFieldTypes.INPUT,
        //   dataField: "userStoryID",
        //   fieldSetting: {
        //     placeholder: "Please Enter User Story",
        //     allowSpace: true,
        //     //  isDisable: true,
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-6 col-md-6 validation-left-0 mb-1",
        //   },
        // },
      ]
    },
    {
      sectionId: "ProjectSynergy3",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-6 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        // {
        //   id: "proposedBy",
        //   label: "Proposed User",
        //   Field_Name: "proposed user",
        //   fieldType: FormFieldTypes.INPUT,
        //   dataField: "proposedBy",
        //   fieldSetting: {
        //     placeholder: "Please Enter Proposed User",
        //     allowSpace: true,
        //     options: [],
        //   },
        //   validation: [{ type: validationTypes.REQUIRE }],
        //   style: {
        //     containerCss: "col-lg-6 col-md-4 validation-left-0 mb-1",
        //   },
        // },

        {
          id: "businessValue",
          label: "Business Value",
          Field_Name: "business value",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "businessValue",
          fieldSetting: {
            placeholder: "Please Enter Business Value",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "expectedOutcomes",
          label: "Expected Outcomes",
          Field_Name: "expected outcomes",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "expectedOutcomes",
          fieldSetting: {
            placeholder: "Please Enter Expected Outcomes",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },
        {
          id: "considerations",
          label: "Considerations",
          Field_Name: "considerations",
          fieldType: FormFieldTypes.TEXTAREA,
          dataField: "considerations",
          fieldSetting: {
            placeholder: "Please Enter Considerations",
            allowSpace: true,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-6 mb-1 validation-left-0",
          },
        },

      ]
    }
  ],
}
